define('home/mixins/asCollapsibleCard',[
    'underscore',
], function (
    _
) {
    'use strict';

    var asCollapsibleCard = function () {
        this.events = _.extend({
            'click [data-action=toggle-collapsed]': 'toggleCollapsed',
        }, this.events);

        this.toggleCollapsed = function (evt) {
            if (evt)
                evt.preventDefault();

            // Use addBack to ensure this view's el is included in the selector
            this.$('.card-collapsed, .card-expanded')
                .addBack('.card-collapsed, .card-expanded')
                .toggleClass('card-collapsed card-expanded');
        };
    };

    return asCollapsibleCard;
});

